import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=0c55e85e"
import script from "./Period.vue?vue&type=script&lang=ts"
export * from "./Period.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports